import React, {useEffect, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, pathname} from "../../components/Utils";
import {
  getFirstImageVariant,
  removeItemFromCartOffer
} from "../../components/UtilsForCart";
import {getItemInOfferCart, updateNotesInOfferCart} from "./OfferCartSlice";
import {useDispatch, useSelector} from "react-redux";
import {LocalParams} from "../../components/LocalParams";
import {RootState} from "../../app/RootReducer";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import ButtonsQuantityMultiple from "../../components/ButtonsQuantityMultiple";
import OfferRequestForm from "./OfferRequestForm";
import HtmlForItemProduct from "../Products/HtmlForItemProduct";
import {renderTextArea} from "../../components/Forms/FormsComponent";
import HaveAnAccountBlock from "../../components/HaveAnAccountBlock";
const OfferRequestPage = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const dispatch = useDispatch()

  const tokenOfferCart = LocalParams.getItem('tokenOfferCart') as string
  const itemsInCartOffer = useSelector((state: RootState) => state.cartOfferRdc.offerCart);

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const isRequesting =  useSelector((state: RootState) => state.cartOfferRdc.isRequesting);
  const isQuantityRequest = useSelector((state: RootState) => state.cartOfferRdc.isRequestingChangeQuantitySuccess)
  const isRequestSuccess =  useSelector((state: RootState) => state.offerRequestRdc.isRequestSuccess);

  /*cart*/
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const notesInOfferCart = useSelector((state: RootState) => state.cartOfferRdc.offerCart?.notes || "");
  const [remarqueText, setRemarqueText] = useState(notesInOfferCart);
  const [showToaster, setShowToaster] = useState(false);
  const isUpdateNoteIsSuccess = useSelector((state:RootState) => state.cartOfferRdc.isUpdateNoteSuccess)
  useEffect(() => {
    setRemarqueText(notesInOfferCart);
  }, [notesInOfferCart]);
  useEffect(() => {
    if(remarqueText != ""){
      const timeoutId = setTimeout(() => {
        if (itemsInCartOffer && remarqueText !== itemsInCartOffer.notes) {
          dispatch(updateNotesInOfferCart(tokenOfferCart, remarqueText));
          if(isUpdateNoteIsSuccess){
            setShowToaster(true)
          }
        }
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [remarqueText]);

  useEffect(() => {
      if(tokenOfferCart){
        dispatch(getItemInOfferCart(tokenOfferCart))
      }
    }, []
  );

  const messageIfNoProduct = () => {
    return(
      <span className="alert alert-warning">
            { t('no_product_yet')} <br/>
            <a href={"/" + locale + "/" + t('url_catalogue')}>Voir le catalogue</a>
      </span>
    )
  }
  const isRequestingAdd = useSelector((state:RootState) => state.userRdc.isRequestingAdd)

  if(pathname === "/" + locale + t('url_request_offer')){
    if(itemsInCart && itemsInCart.items.length > 0){
      window.location.href = "/" + locale + t('url_cart');
    }
  }

  useEffect(() => {
    if(pathname === "/" + locale + t('url_cart')){
      if(itemsInCart?.items.length === 0 && itemsInCartOffer && itemsInCartOffer?.items.length > 0){
        window.location.href = "/" + locale + t('url_request_offer');
      }
    }
    }, [itemsInCart?.items]
  );

  return (
    isRequesting ?
      <SpinnerOnTop/>
      :
      !isRequestSuccess ?
        tokenOfferCart?
          <>
            {
              itemsInCart === null || itemsInCart.items.length === 0  ?
                <div className="pdt-60 pdb-120 border-top bg-circle py-5">
                  <div className="container">
                    <div className="row mb-5 pt-5">
                      <header className="section-heading text-center">
                        <h3 className="section-title h1">{t('request_offer_for_products')}</h3>
                        <p className="lead mb-0">{ t('intro_text_request_offer') }</p>
                      </header>
                    </div>
                    <div className="row">
                      {
                        itemsInCartOffer && itemsInCartOffer.items.length === 0 && pathname !== t('url_cart') && isAuthenticated ?
                          messageIfNoProduct()
                          :
                          <>
                            <div className="col-md-6">
                              {
                                isRequesting || isQuantityRequest ?
                                  <SpinnerOnTop/>
                                  :
                                  tokenOfferCart ?
                                    <div className="row">
                                      {
                                        itemsInCartOffer && itemsInCartOffer.items.map((itemCartOffer) => {
                                          return(
                                            <div className="col-sm-6 col-12" key={itemCartOffer.variant.product.name}>
                                              <div className="card card-product-grid height100">
                                                <button className="close-modale delete-item borderradius50" id={"tooltip-"} data-toggle="tooltip" data-placement="top"
                                                        title={t('delete_product')} data-original-title={t('delete_product')} onClick={() => removeItemFromCartOffer(itemCartOffer.variant.code, tokenOfferCart, dispatch)}>
                                                  <span aria-hidden="true">×</span>
                                                </button>
                                                <div className="img-wrap">
                                                  <div className="float-lg-end">
                                                  </div>
                                                  <img src={getFirstImageVariant(itemCartOffer.variant)} alt={itemCartOffer.variant.product.name}/>
                                                </div>
                                                <div className="info-wrap border-top height100 flex1 d-flex flex-column">
                                                  <h4>
                                                    <a href={"/" + locale + t('url_detail_product') + "/" + itemCartOffer.variant.product.slug} className="text-black">{ itemCartOffer.variant.product.name }</a>
                                                  </h4>
                                                  <div className="variation margintopauto row">
                                                    <label className="form-label">{t('quantity')}</label>
                                                    <ButtonsQuantityMultiple quantityInCart={itemCartOffer.quantity}
                                                                             variantCode={itemCartOffer.variant.code}
                                                                             tokenValue={tokenOfferCart}
                                                                             dispatch={dispatch}
                                                                             isCartQuantity={false}/>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                    : null
                              }
                            </div>
                            <div className="col-md-6">
                              <article className="card mb-4">
                                <div className="content-body">
                                  <OfferRequestForm itemsInCartOffer={itemsInCartOffer} remarqueText={remarqueText} setRemarqueText={setRemarqueText}/>
                                </div>
                              </article>
                            </div>
                          </>
                      }
                    </div>
                  </div>
                </div>
                :
                <>
                  {
                    isRequesting || isQuantityRequest ?
                      <SpinnerOnTop/>
                      :
                      itemsInCartOffer && itemsInCartOffer.items.length > 0 ?
                        <>
                          <h4 className="card-title mb-4">{t('your_request_offer')}</h4>
                          {
                            itemsInCartOffer.items.map((itemCartOffer, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <HtmlForItemProduct
                                    productItem={itemCartOffer}
                                    isForCart={false}
                                    isItemForRequestOffer={true}
                                    tokenValue={tokenOfferCart}
                                    isRequestingAdd={isRequestingAdd}
                                    dispatch={dispatch}
                                  />
                                </React.Fragment>
                              )
                            })
                          }
                          <div className="col-12 mb-3">
                            {
                              renderTextArea(t('add_remark'), "notes", false, setRemarqueText, remarqueText)
                            }
                          </div>
                        </>
                        : null
                  }
                </>
            }
          </>
          :
          <div className="container">
              {
                itemsInCartOffer === null && pathname !== "/" + locale + t('url_cart') && isAuthenticated?
                  <div className="row">
                    {messageIfNoProduct()}
                  </div>
                  :
                  !isAuthenticated ?
                    <HaveAnAccountBlock/>
                  : null
              }
          </div>
        :
        <div className="container">
          <div className="row">
            <div className="alert alert-success">
              { t('request_send')}
            </div>
          </div>
        </div>
  )
}

export default OfferRequestPage;
